import React from 'react';
import PropTypes from 'prop-types';
import './index.css';
import { useTranslation } from 'react-i18next';
import Faq from '../../components/Common/Faq';

const Faqs = ({ landingPageData }) => {
  const { t } = useTranslation();

  // Get restaurant name dynamically
  const restaurantName = landingPageData?.landingPage?.title ||
      landingPageData?.restaurant?.name ||
      t('landing.restaurant_generic', 'Restaurant');

  // Default FAQs for the first section if landing page data doesn't have any
  const defaultRestaurantFaqs = [
    { question: 'courier.faq_question_1', answer: 'courier.faq_answer_1' },
    { question: 'courier.faq_question_2', answer: 'courier.faq_answer_2' },
    { question: 'courier.faq_question_3', answer: 'courier.faq_answer_3' },
    { question: 'courier.faq_question_4', answer: 'courier.faq_answer_4' },
    { question: 'courier.faq_question_5', answer: 'courier.faq_answer_5' }
  ];

  // These sections are always included
  const orderingSnapFoodFaqs = [
    { question: 'courier.faq_question_6', answer: 'courier.faq_answer_6' },
    { question: 'courier.faq_question_7', answer: 'courier.faq_answer_7' },
    { question: 'courier.faq_question_8', answer: 'courier.faq_answer_8' },
    { question: 'courier.faq_question_9', answer: 'courier.faq_answer_9' },
    { question: 'courier.faq_question_10', answer: 'courier.faq_answer_10' }
  ];

  const partnershipFaqs = [
    { question: 'courier.faq_question_11', answer: 'courier.faq_answer_11' },
    { question: 'courier.faq_question_12', answer: 'courier.faq_answer_12' },
    { question: 'courier.faq_question_13', answer: 'courier.faq_answer_13' },
    { question: 'courier.faq_question_14', answer: 'courier.faq_answer_14' }
  ];

  return (
      <div className="faqs-container">
        <h2>{t('landing.faq.title')}</h2>
        <div className="faqs-content">
          <div className="faq-section">
            <h3>{t('landing.about_restaurant', 'About')} {restaurantName}</h3>
            {landingPageData?.landingPage?.faqs?.length > 0 ? (
                // Landing page FAQs - use directly
                landingPageData.landingPage.faqs.map((faq, index) => (
                    <Faq
                        key={index}
                        question={faq.question}
                        answer={faq.answer}
                    />
                ))
            ) : (
                // Default FAQs - use translation
                defaultRestaurantFaqs.map((faq, index) => (
                    <Faq
                        key={index}
                        question={t(faq.question)}
                        answer={t(faq.answer)}
                    />
                ))
            )}
          </div>

          <div className="faq-section">
            <h3>{t('landing.ordering_through_snapfood', 'Ordering through SnapFood')}</h3>
            {orderingSnapFoodFaqs.map((faq, index) => (
                <Faq
                    key={index}
                    question={t(faq.question)}
                    answer={t(faq.answer)}
                />
            ))}
          </div>

          <div className="faq-section">
            <h3>{t('landing.partnership_with_snapfood', 'SnapFood and')} {restaurantName} {t('landing.partnership', 'Partnership')}</h3>
            {partnershipFaqs.map((faq, index) => (
                <Faq
                    key={index}
                    question={t(faq.question)}
                    answer={t(faq.answer)}
                />
            ))}
          </div>
        </div>
      </div>
  );
};

Faqs.propTypes = {
  landingPageData: PropTypes.object
};

export default Faqs;